export function getPathLogin() {
  return `/login`;
}

export function getPathLogout() {
  return `/logout`;
}

export function getPathRegister() {
  return `/register`;
}

export function getPathRegisterComplete() {
  return `/register/complete`;
}

export function getPathRegisterCompleteVerify() {
  return `/register/complete/verify`;
}

export function getPathResetPassword() {
  return `/password/reset`;
}

export function getPathResetPasswordDone() {
  return `/password/reset/done`;
}

export function getPathSetNewPassword(uidb64, token) {
  return `/password/new/${uidb64}/${token}`;
}

export function getPathSetNewPasswordComplete() {
  return `/password/new/complete`;
}

export function getPathSetPasswordAddedUser(key) {
  return `/set-password-added-user/${key}`;
}

// Note: `process` path is added to avoid clash with `getPathSetPasswordAddedUser`
export function getPathSetPasswordAddedUserComplete() {
  return `/set-password-added-user-complete`;
}

export function getPathUnverified() {
  return `/unverified`;
}

export function getPathOAuthLogin() {
  return `/oauth-login`;
}
